<template>
  <div class="unfinished-item">
    <div class="unfinished-item__file">
      <p class="unfinished-item__file-name">{{ fileId }}</p>
      <p class="unfinished-item__file-extension">{{ fileExt }}</p>
    </div>
    <div class="file-info__controls">
      <button class="button unfinished-item__file-check" @click="onClick">
        <i class="fa fa-refresh" aria-hidden="true" />
      </button>
      <button class="button unfinished-item__file-check" @click="onRemoveClicked">
        <i class="fa fa-times" aria-hidden="true" />
      </button>
    </div>
    <input
      ref="fileInput"
      class="unfinished-item__hidden-input"
      type="file"
      :accept="acceptedFiles"
      @change="onFileChange"
    >
  </div>
</template>

<script>
export default {
  name: 'UnfinishedItem',
  props: {
    filename: {
      type: String,
      required: true,
    },
    acceptedFiles: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    fileId: '',
    fileExt: '',
  }),

  mounted() {
    this.splitFileName(this.filename);
  },

  methods: {
    onClick() {
      this.$refs.fileInput.click();
    },
    onRemoveClicked() {
      this.$emit('remove-clicked');
    },
    onFileChange(e) {
      if (e.currentTarget.files) {
        this.$emit('file-selected', e.currentTarget.files[0]);
      }
    },
    splitFileName(name) {
      const lastPoint = name.lastIndexOf('.');
      this.fileId = name.substring(0, lastPoint);
      this.fileExt = name.substring(lastPoint);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ListItem.vue?5f8c02ba